import { z } from 'zod'
import { EndDate, Id, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace HouseType {
  export interface Data {
    /** @description Ownership indicator */
    readonly id: number

    /** @description Name */
    readonly name: string

    /** @description Short name */
    readonly shortName?: string

    /** @description Description */
    readonly description?: string

    /** @description Record entry (update) date */
    readonly updatedDate: Date

    /** @description Record validity start */
    readonly startDate: Date

    /** @description Record validity end */
    readonly endDate: Date

    /** @description Record action status */
    readonly isActive: boolean
  }
}

const SCHEMA: GarItem.Schema<HouseType.Data> = z
  .strictObject({
    ID: Id,

    NAME: z.string().describe('Name'),

    SHORTNAME: z.string().optional().describe('Short name'),

    DESC: z.string().optional().describe('Description'),

    UPDATEDATE: UpdateDate,

    STARTDATE: StartDate,

    ENDDATE: EndDate,

    ISACTIVE: IsActive,
  })
  .transform<HouseType.Data>(attributes => ({
    id: attributes.ID,
    name: attributes.NAME,
    shortName: attributes.SHORTNAME,
    description: attributes.DESC,
    updatedDate: attributes.UPDATEDATE,
    startDate: attributes.STARTDATE,
    endDate: attributes.ENDDATE,
    isActive: attributes.ISACTIVE,
  }))

/** @description Information about ownership indicators */
export class HouseType extends GarItem<'HouseType', HouseType.Data> {
  static readonly SCHEMA = SCHEMA

  readonly type = 'HouseType'

  protected get schema() {
    return HouseType.SCHEMA
  }
}

/** @description Information about ownership indicators */
export class AdditionalHouseType extends GarItem<
  'AdditionalHouseType',
  HouseType.Data
> {
  static readonly SCHEMA = SCHEMA

  readonly type = 'AdditionalHouseType'

  protected get schema() {
    return AdditionalHouseType.SCHEMA
  }
}
